<template>
  <div>
      <div class="flex w-full flex-col gap-11">
      <div class="flex flex-row items-center justify-between">
        <span class="text-5xl font-medium">{{ __('New Pipeline') }}</span>
      </div>
      <PipelineForm
        :data="formData"
        :errors="errors"
        @submitForm="handleSubmit"
        :submitText="__('Create Pipeline')"
      />
    </div>
  </div>
</template>

<script setup>
  import { reactive, ref } from 'vue';
  import { useToast } from 'vue-toastification';
  import PipelineForm from './components/PipelinesForm.vue';

  import { __ } from '@/helpers';
  const props = defineProps({
    data: Object
  });
  const toast = useToast();

  const formData = reactive({
    ...(props.data || {})
  });
  const errors = ref({});
  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        route('redesign.company.pipelines.store'),
        formData.pipeline
      );

      sessionStorage.setItem(
        'toast_message',
        JSON.stringify({
          type: 'success',
          message: response.data.message
        })
      );

      window.location.href = response.data.redirect_url;
    } catch (error) {
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
        errors.value = error.response.data.errors;
      } else {
        toast.error(__('Something went wrong'));
      }
    }
  };
</script>
